<template>
  <a-modal :width="530" class="phoneModal" v-model:visible="phone.visible">
    <template #title>
      <h1 class="phone-title">
        <span>已关联手机号</span>
        <span class="tips">1名用户可关联9个手机号</span>
      </h1>
    </template>
    <div class="phone-box">
      <div class="phones">
        <span class="phones_label">绑定手机号:</span>
        <span class="">{{ phone.bindPhone }}</span>
      </div>
      <div ref="phonesDOM" class="phones" v-for="(item, index) in phone.data" :key="item.id">
        <span class="phones_label">
          {{ `关联号码 ${index + 1}:` }}
        </span>
        <span>
          {{ item.phone }}
          <a-popconfirm
            :getPopupContainer="() => phonesDOM[index]"
            title="确定删除关联号码？"
            ok-text="删除"
            cancel-text="取消"
            @confirm="deletePhone(item.id)"
            placement="bottom"
            :okButtonProps="{ danger: true, size: 'default' }"
            :cancelButtonProps="{ size: 'default' }"
          >
            <a-button type="link" size="small" :danger="true">删除</a-button>
          </a-popconfirm>

          <a-popconfirm
            :getPopupContainer="() => phonesDOM[index]"
            title="确定拨打该电话？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleCall(item)"
            placement="bottom"
            :okButtonProps="{ danger: true, size: 'default' }"
            :cancelButtonProps="{ size: 'default' }"
          >
            <a-button type="link" size="small" :danger="true">拨打电话</a-button>
          </a-popconfirm>
          <a-button type="link" size="small" :danger="true" @click="handleViewArchive(item)">
            查看档案
          </a-button>
        </span>
      </div>
      <!-- 新增手机号 -->
      <div v-show="phone.isAddPhone" class="phones">
        <span class="phones_label">
          {{ `关联号码 ${phone.data.length + 1}:` }}
        </span>
        <a-input class="input" size="large" v-model:value="phone.addPhone" placeholder="请输入" />
      </div>
    </div>
    <template #footer>
      <a-button @click="cancelPhone">取消</a-button>
      <a-button
        v-if="!phone.isAddPhone"
        type="primary"
        :disabled="phone.data.length >= 9"
        @click="addPhone"
      >
        新增
      </a-button>
      <a-button v-else type="primary" @click="onSavePhone">保存</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { deletePhoneById, getPhoneByPatientId, savePhone } from '@/api/patientFile'
import { getUserInfoByType } from '@/api/UserPool'
import { validPhone } from '@/utils/validate'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import { computed, createVNode, defineExpose, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { callOut } from '@/utils/Tccc'
import useRevisitPoolGuard from '@/hooks/useRevisitPoolGuard'
const store = useStore()
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)

const phonesDOM = ref([])
const phone = reactive({
  visible: false,
  bindPhone: '',
  addPhone: '',
  isAddPhone: false,
  data: []
})
const addPhone = () => {
  phone.isAddPhone = true
  phone.addPhone = ''
}
const open = () => {
  // 获取关联手机号
  const params = {
    patientId: info.value.patientId || info.value.prePatientId,
    patientType: patientType.value
  }
  getPhoneByPatientId(params).then(result => {
    phone.visible = true
    phone.data = result
  })
  // 获取患者绑定手机号
  const params2 = {
    accountType: patientType.value ? 1 : -1,
    id: info.value.patientId || info.value.prePatientId
  }
  getUserInfoByType(params2).then(res => {
    phone.bindPhone = res.phone
  })
}
const onSavePhone = () => {
  const valid = validPhone(phone.addPhone)
  // 无效手机号 直接提示
  if (valid === false) {
    message.warning('无效手机号')
    return
  }
  saveAPI()
}
const saveAPI = () => {
  const { name, gender, age, phone: _phone, patientId, prePatientId } = info.value
  const params = {
    patientId: patientId || prePatientId,
    patientType: patientType.value,
    patientInfo: {
      patientName: name,
      gender: gender,
      age: age,
      phone: _phone
    },
    phone: phone.addPhone,
    ucPatientId: info.value.ucPatientId,
    matchFlag: 1
  }
  savePhone(params).then(result => {
    // 老患者标志 0-不是1-是
    if (result.oldPatientFlag) {
      Modal.confirm({
        title: () => '提示?',
        icon: () => createVNode(ExclamationCircleOutlined),
        content: `手机号：${result.phone}，匹配到为患者：${result.patientName}，请问是否关联并展示档案？`,
        cancelText: '不关联',
        okText: '关联',
        onOk() {
          message.success('操作成功')
          refresh()
          cancelPhone()
        },
        onCancel() {
          const params = {
            patientId: patientId || prePatientId,
            patientType: patientType.value,
            patientInfo: {
              patientName: name,
              gender: gender,
              age: age,
              phone: _phone
            },
            phone: phone.addPhone,
            ucPatientId: info.value.ucPatientId,
            matchFlag: 0 // 重新发起请求移除关联字段
          }
          savePhone(params).then(_ => {
            message.success('操作成功')
            refresh()
            cancelPhone()
          })
        }
      })
    } else {
      message.success('操作成功')
      refresh()
      cancelPhone()
    }
  })
}
const deletePhone = id => {
  // console.log(id)
  const params = { id }
  deletePhoneById(params)
    .then(result => {
      cancelPhone()
      message.success('操作成功')
      refresh()
    })
    .catch(err => {})
}
const cancelPhone = () => {
  phone.isAddPhone = false
  phone.addPhone = ''
  phone.visible = false
}
const refresh = () => {
  store.dispatch('patientFile/getInfo')
}
const handleCall = item => {
  const doCall = crossPoolParams => {
    const params = {
      calleeType: 1,
      calleeUcUserId: info.value?.ucPatientId || '',
      doctorId: '',
      workOrderIds: [],
      businessType: 0,
      phone: item.phone,
      // 跨回访池确认拨打埋点参数，随拨打参数透传至 record-save-before-call
      ...crossPoolParams
    }
    callOut(params, {
      userType: '患者',
      name: info.value?.name || ''
    })
  }
  // 拨打患者前先校验是否已在其他健管回访池中（非结束态）；原流程无二次确认，onPass/onContinue 同为直接拨打
  useRevisitPoolGuard({
    ucPatientId: info.value?.ucPatientId || '',
    source: 'patientFile',
    onPass: doCall,
    onContinue: doCall,
    // 本次需求不处理「关联手机号」拨打的自动加入回访池提示，仅保留原跨回访池校验
    skipAutoJoinPrompt: true
  })
}
// 查看患者档案
const handleViewArchive = item => {
  const params = {
    param: item,
    callBack: () => {
      phone.visible = false
    }
  }
  store.dispatch('patientFile/handleViewArchive', params)
}
defineExpose({
  open
})
</script>

<style lang="scss" scoped>
.phoneModal {
  .phone-title {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    .tips {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      margin-left: 8px;
    }
  }
  .phone-box {
    .phones {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333333;
      margin-top: 16px;
      &:first-child {
        margin-top: 0;
      }
      .phones_label {
        margin-right: 8px;
        width: 90px;
        color: #666666;
        margin: 0;
        flex-shrink: 0;
      }
      .input {
        border-radius: 4px;
      }
      ::v-deep(.ant-popover-inner-content) {
        width: 300px;
      }
    }
  }
}
</style>
